import {KorterConverter} from "./KorterConverter";
import { Proposal, ProposalResource, Source } from "../types/Proposal";
import { PartialRecord } from "../types/GeneralTypes";
import { GoodPlaceGeorgiaConverter } from "./GoodPlaceGeorgiaConverter";



const ingestorConverters:PartialRecord<Source, PartialRecord<keyof Proposal, (data:unknown) => unknown>> = {
    korter: KorterConverter
}
const resourceConverters:PartialRecord<Source, PartialRecord<keyof ProposalResource, (data:unknown) => unknown>> = {
    goodplacegeorgia: GoodPlaceGeorgiaConverter
}

export function adaptData(converter:string, field: keyof Proposal, data:unknown) {
    //@ts-ignore
    if(ingestorConverters[converter]) {
        //@ts-ignore
        if(ingestorConverters[converter][field]) {
            //@ts-ignore
            return ingestorConverters[converter][field](data);
        }
    }
    return data;
}
export function adaptImageData(converter:string, field: keyof ProposalResource, data:unknown) {
    //@ts-ignore
    if(resourceConverters[converter]) {
        //@ts-ignore
        if(resourceConverters[converter][field]) {
            //@ts-ignore
            return resourceConverters[converter][field](data);
        }
    }
    return data;
}